import Logo from 'layouts/logo/logo';
// @ts-ignore
import LogoImage from 'assets/images/logo.svg';
import TermsOfUseContent from 'components/legal/terms-of-use-content';
import {
  PrivacyShell,
  PrivacyInner,
  PrivacyLogoWrap,
  PrivacyPage as TermsDocument
} from 'components/legal/privacy-document.style';

const TermsPage = () => (
  <PrivacyShell>
    <PrivacyInner>
      <PrivacyLogoWrap>
        <Logo text="Wallet" imageUrl={LogoImage} />
      </PrivacyLogoWrap>
      <TermsDocument>
        <TermsOfUseContent />
      </TermsDocument>
    </PrivacyInner>
  </PrivacyShell>
);

export default TermsPage;
